import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Input, Select, DatePicker, Form, Row, Col, Button, Icon} from 'antd';
import {ExTable, SmallPopover} from 'icsoc-antd-ex';
import UnionSearch from 'Components/union/unionSearch';
import IconFont from 'Components/common/iconFont';
import tDetailActions from 'Actions/taskManage/detail';
// import {getWeekDays} from 'Utils';
import moment from 'moment';
import {progress, result, result2} from './config';

const {
  Filter,
  Filter: {NormalFilter, MoreFilter},
} = ExTable;
const {Option} = Select;
const {RangePicker} = DatePicker;
const formItemLayout = {labelCol: 7, wrapperCol: 17};

function formatData(date = '') {
  return date && moment(parseInt(date, 10));
}

function formatDataArray(date = []) {
  let dateStart;
  let dateEnd;

  if (Array.isArray(date) && date.length > 0) {
    dateStart = (date[0] && date[0].format('x')) || undefined;
    dateEnd = (date[1] && date[1].format('x')) || undefined;
  }
  return [dateStart, dateEnd];
}

class Search extends UnionSearch {
  constructor(props) {
    super(props);

    this.state = {
      expand: true,
    };
  }

  componentDidMount() {
    this.customize = localStorage.getItem('customize') || '';
    this.getALLOptions();
  }

  // 获取任务名称下拉框+话术名称下拉框
  getALLOptions = () => {
    const {actions} = this.props;

    actions.getTaskNameOptions();
    actions.getWordStrategyIdOptions();
  };

  // 点击查询
  handleFilter = fields => {
    const {actions, searchData, setDownloadData, form, getTableComponent} = this.props;
    const values = this.customize === 'txgg' ? fields : form.getFieldsValue();
    const {
      commitTime = [],
      taskCommitDate = [],
      interactNum = [],
      usefulInteractNum = [],
      lastTime = [],
      ...otherFields
    } = values;
    const formatCommitTime = formatDataArray(commitTime);
    const formatTaskCommitDate = formatDataArray(taskCommitDate);

    const params = {
      ...otherFields,
      commitTimeStart: formatCommitTime[0],
      commitTimeEnd: formatCommitTime[1],
      taskCommitDateStart: formatTaskCommitDate[0],
      taskCommitDateEnd: formatTaskCommitDate[1],
      interactNum: interactNum.join(','),
      usefulInteractNum: usefulInteractNum.join(','),
      lastTime: lastTime.join(';'),
    };
    actions.setSelectdRowKeys([]);
    setDownloadData({...searchData, ...params});
    const TableComponent = getTableComponent();
    if(values.taskId&&TableComponent) {
      TableComponent.getHeaderCustomColumn(values.taskId, () => {this.onOk(params)})
    } else {
      TableComponent.reset_custom_column(() => {this.onOk(params)})
    }
  };

  // 重置筛选
  resetFilter = () => {
    const params = {
      commitTimeStart: moment(
        `${moment(new Date()).format('YYYY-MM-DD')} 00:00:00`,
      ).format('x'),
      commitTimeEnd: moment(
        `${moment(new Date()).format('YYYY-MM-DD')} 23:59:59`,
      ).format('x'),
      orderKey: 'commit_time',
    };
    this.searchByData(params);
    this.props.form.resetFields();
  };

  toggle = () => {
    const {expand} = this.state;
    this.setState({expand: !expand});
  };

  getResultObject = () => {
    let user = localStorage.getItem('user') || '{}';
    user = JSON.parse(user)
    let vccId = user?.profile?.vcc_id

    if (['2002361', '1018'].includes(vccId)) {
      return result2
    }

    return result
  }

  render() {
    const {
      taskNameOptions,
      wordStrategyIdOptions,
      searchData,
      form: {getFieldDecorator},
      form,
    } = this.props;
    const {
      taskId,
      commitTimeStart,
      commitTimeEnd,
      taskCommitDateStart,
      taskCommitDateEnd,
      orderKey,
      interactNum = '',
      usefulInteractNum = '',
      lastTime,
    } = searchData;
    const values = form.getFieldsValue();
    const {commitTime = [], taskCommitDate = []} = values;
    const {expand} = this.state;
    const result = this.getResultObject()
    return (
      <div>
        {this.customize === 'txgg' ? (
          <Filter
            handleFilter={this.handleFilter}
            resetNormalFilter={this.resetFilter}>
            <NormalFilter>
              <NormalFilter.Item
                label="任务名称"
                field="taskId"
                initialValue={taskId || undefined}>
                <Select
                  showSearch
                  allowClear
                  placeholder="请输入内容"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }>
                  {Array.isArray(taskNameOptions)
                    ? taskNameOptions.map(({taskId, taskName}) => (
                        <Option value={taskId} key={taskId}>
                          {taskName}
                        </Option>
                      ))
                    : null}
                </Select>
              </NormalFilter.Item>
              <NormalFilter.Item style={{width:250}}
                label="提交时间"
                field="commitTime"
                initialValue={[
                  formatData(commitTimeStart),
                  formatData(commitTimeEnd),
                ]}>
                <RangePicker
                  allowClear={false}
                  placeholder={['开始日期', '结束日期']}
                  showTime={{
                    hideDisabledOptions: true,
                    defaultValue: [
                      moment('00:00:00', 'HH:mm:ss'),
                      moment('23:59:59', 'HH:mm:ss'),
                    ],
                  }}
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </NormalFilter.Item>
            </NormalFilter>
            <MoreFilter formItemLayout={formItemLayout} key={1}>
              <MoreFilter.Item
                label={
                  <span className="search-item-label">
                    <SmallPopover type="white" content="呼叫唯一标识：JobId">
                      <IconFont
                        type="icon-robotrobotinfo-fill"
                        style={{
                          color: 'rgba(0,0,0,.45)',
                          margin: '0 4px',
                        }}
                      />
                    </SmallPopover>
                    呼叫标识
                  </span>
                }
                fieldOptions={{
                  getValueFromEvent: e => e.target.value.replace(/\D/g, ''),
                }}
                field="jobId">
                <Input placeholder="请输入JobId" />
              </MoreFilter.Item>
              <MoreFilter.Item label="联系进度" field="progress">
                <Select placeholder="请选择">
                  <Option value="-1">全部</Option>
                  {Object.keys(progress).map(item => (
                    <Option key={item} value={item}>
                      {progress[item]}
                    </Option>
                  ))}
                </Select>
              </MoreFilter.Item>
              <MoreFilter.Item label="联系结果" field="result">
                <Select placeholder="请选择">
                  <Option value="-1">全部</Option>
                  {Object.keys(result).map(item => (
                    <Option key={item} value={item}>
                      {result[item]}
                    </Option>
                  ))}
                </Select>
              </MoreFilter.Item>
              <MoreFilter.Item label="主叫号码" field="callNumber">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="第三方标识" field="clientName">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="客户电话" field="phone">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="地区（省）" field="province">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="地区（市）" field="city">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="联系人(公司名称)" field="address">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="手机" field="mobile">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="座机" field="tel">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="客户意向度结果" field="label">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="客户应答次数" field="answerTimes">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item label="呼叫时长" field="lastTime">
                <Input placeholder="请输入内容" />
              </MoreFilter.Item>
              <MoreFilter.Item
                label="排序字段"
                field="orderKey"
                initialValue={orderKey}>
                <Select placeholder="请选择">
                  <Option value="commit_time">提交时间</Option>
                  <Option value="call_time">呼出时间</Option>
                </Select>
              </MoreFilter.Item>
            </MoreFilter>
          </Filter>
        ) : (
          <Form
            className="ant-advanced-search-form taskDetailFilter"
            labelAlign="right">
            <Row>
              <Col span={6}>
                <Form.Item label="任务名称">
                  {getFieldDecorator('taskId', {
                    initialValue:taskId || undefined
                  })(
                    <Select
                      showSearch
                      allowClear
                      placeholder="请输入内容"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }>
                      {Array.isArray(taskNameOptions)
                        ? taskNameOptions.map(({taskId, taskName}) => (
                            <Option value={taskId} key={taskId}>
                              {taskName}
                            </Option>
                          ))
                        : null}
                    </Select>,
                  )}
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item label="提交时间">
                  {getFieldDecorator('commitTime', {
                    initialValue: [
                      formatData(commitTimeStart),
                      formatData(commitTimeEnd),
                    ],
                  })(
                    <RangePicker
                      allowClear={
                        taskCommitDate.length !== 0 && taskCommitDate[0] !== ''
                      }
                      placeholder={['开始日期', '结束日期']}
                      showTime={{
                        hideDisabledOptions: true,
                        defaultValue: [
                          moment('00:00:00', 'HH:mm:ss'),
                          moment('23:59:59', 'HH:mm:ss'),
                        ],
                      }}
                      format="YYYY-MM-DD HH:mm:ss"
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col span={5} key={5}>
                <Form.Item label="联系进度">
                  {getFieldDecorator('progress', {
                    initialValue: searchData.progress,
                  })(
                    <Select placeholder="请选择">
                      <Option value="-1">全部</Option>
                      {Object.keys(progress).map(item => (
                        <Option key={item} value={item}>
                          {progress[item]}
                        </Option>
                      ))}
                    </Select>,
                  )}
                </Form.Item>
              </Col>

              {expand ? (
                <Col span={6}>
                  <Form.Item label="联系结果">
                    {getFieldDecorator('result', {
                      initialValue: searchData.result,
                    })(
                      <Select placeholder="请选择">
                        <Option value="-1">全部</Option>
                        {Object.keys(result).map(item => (
                          <Option key={item} value={item}>
                            {result[item]}
                          </Option>
                        ))}
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
              ) : (
                <Col span={6} key={6}>
                  <Button type="primary" onClick={this.handleFilter}>
                    查询
                  </Button>
                  <Button style={{marginLeft: 8}} onClick={this.resetFilter}>
                    重置
                  </Button>
                  <a style={{marginLeft: 8}} onClick={this.toggle}>
                    <span>
                      更多搜索<Icon type="down" />
                    </span>
                  </a>
                </Col>
              )}
            </Row>
            {expand && this.customize === 'xy' ? (
              <div>
                <Row>
                  <Col span={6}>
                    <Form.Item label="排序字段">
                      {getFieldDecorator('orderKey', {
                        initialValue: orderKey,
                      })(
                        <Select placeholder="请选择">
                          <Option value="commit_time">提交时间</Option>
                          <Option value="call_time">呼出时间</Option>
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label={
                        <span className="search-item-label">
                          <SmallPopover
                            type="white"
                            content="呼叫唯一标识：JobId">
                            <IconFont
                              type="icon-robotrobotinfo-fill"
                              style={{
                                color: 'rgba(0,0,0,.45)',
                                margin: '0 4px',
                              }}
                            />
                          </SmallPopover>
                          呼叫标识
                        </span>
                      }>
                      {getFieldDecorator('jobId', {
                        getValueFromEvent: e =>
                          e.target.value.replace(/\D/g, ''),
                        initialValue: searchData.jobId,
                      })(<Input placeholder="请输入呼叫标识" />)}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="UID">
                      {getFieldDecorator('uid', {
                        initialValue: searchData.uid,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="第三方标识">
                      {getFieldDecorator('clientName', {
                        initialValue: searchData.clientName,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={6}>
                    <Form.Item label="客户电话">
                      {getFieldDecorator('phone', {
                        initialValue: searchData.phone,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="主叫号码">
                      {getFieldDecorator('callNumber', {
                        initialValue: searchData.callNumber,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="通话轮次">
                      {getFieldDecorator('interactNum', {
                        initialValue: interactNum ? interactNum.split(',') : [],
                      })(
                        <Select placeholder="请选择" mode="multiple">
                          <Option value="0">0轮</Option>
                          <Option value="1">1轮</Option>
                          <Option value="2">2轮</Option>
                          <Option value="3">3轮</Option>
                          <Option value="4">4轮</Option>
                          <Option value="5">5轮</Option>
                          <Option value="6">6轮</Option>
                          <Option value="7">6轮以上</Option>
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="有效通话轮次">
                      {getFieldDecorator('usefulInteractNum', {
                        initialValue: usefulInteractNum
                          ? usefulInteractNum.split(',')
                          : [],
                      })(
                        <Select placeholder="请选择" mode="multiple">
                          <Option value="0">0轮</Option>
                          <Option value="1">1轮</Option>
                          <Option value="2">2轮</Option>
                          <Option value="3">3轮</Option>
                          <Option value="4">4轮</Option>
                          <Option value="5">5轮</Option>
                          <Option value="6">6轮</Option>
                          <Option value="7">6轮以上</Option>
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={6}>
                    <Form.Item label="通话时长">
                      {getFieldDecorator('lastTime', {
                        initialValue: lastTime ? lastTime.split(';') : [],
                      })(
                        <Select placeholder="请选择" mode="multiple">
                          <Option value="0,10">1-10秒</Option>
                          <Option value="10,30">10-30秒</Option>
                          <Option value="30,60">30秒-1分钟</Option>
                          <Option value="60,120">1分钟-2分钟</Option>
                          <Option value="120,600">2分钟以上</Option>
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="意向标签">
                      {getFieldDecorator('code', {
                        initialValue: searchData.code,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="人工纠错">
                      {getFieldDecorator('correctResult', {
                        initialValue: searchData.correctResult,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="呼出时间">
                      {getFieldDecorator('taskCommitDate', {
                        initialValue: [
                          formatData(taskCommitDateStart),
                          formatData(taskCommitDateEnd),
                        ],
                      })(
                        <RangePicker
                          allowClear={
                            commitTime.length !== 0 && commitTime[0] !== ''
                          }
                          placeholder={['开始日期', '结束日期']}
                          showTime={{
                            hideDisabledOptions: true,
                            defaultValue: [
                              moment('00:00:00', 'HH:mm:ss'),
                              moment('23:59:59', 'HH:mm:ss'),
                            ],
                          }}
                          format="YYYY-MM-DD HH:mm:ss"
                        />,
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={6}>
                    <Form.Item label="话术名称">
                      {getFieldDecorator('wordStrategyId', {
                        initialValue: searchData.wordStrategyId,
                      })(
                        <Select
                            showSearch
                            allowClear
                            placeholder="请输入内容"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }>
                          <Option value={-1}>全部</Option>
                          {Array.isArray(wordStrategyIdOptions)
                            ? wordStrategyIdOptions.map(
                                ({id, strategyName}) => (
                                  <Option
                                    value={id && parseInt(id, 10)}
                                    key={id}>
                                    {strategyName}
                                  </Option>
                                ),
                              )
                            : null}
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="CallId">
                      {getFieldDecorator('callId', {
                        initialValue: searchData.callId,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{marginBottom: 20}}>
                  <Col span={6}>
                    <Button type="primary" onClick={this.handleFilter}>
                      查询
                    </Button>
                    <Button style={{marginLeft: 8}} onClick={this.resetFilter}>
                      重置
                    </Button>
                    <a style={{marginLeft: 8}} onClick={this.toggle}>
                      <span>
                        收起<Icon type="up" />
                      </span>
                    </a>
                  </Col>
                </Row>
              </div>
            ) : null}
            {expand && this.customize === '' ? (
              <div>
                <Row>
                  <Col span={6}>
                    <Form.Item label="排序字段">
                      {getFieldDecorator('orderKey', {
                        initialValue: orderKey,
                      })(
                        <Select placeholder="请选择">
                          <Option value="commit_time">提交时间</Option>
                          <Option value="call_time">呼出时间</Option>
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label={
                        <span className="search-item-label">
                          <SmallPopover
                            type="white"
                            content="呼叫唯一标识：JobId">
                            <IconFont
                              type="icon-robotrobotinfo-fill"
                              style={{
                                color: 'rgba(0,0,0,.45)',
                                margin: '0 4px',
                              }}
                            />
                          </SmallPopover>
                          呼叫标识
                        </span>
                      }>
                      {getFieldDecorator('jobId', {
                        getValueFromEvent: e =>
                          e.target.value.replace(/\D/g, ''),
                        initialValue: searchData.jobId,
                      })(<Input placeholder="请输入JobId" />)}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="第三方标识">
                      {getFieldDecorator('clientName', {
                        initialValue: searchData.clientName,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="客户电话">
                      {getFieldDecorator('phone', {
                        initialValue: searchData.phone,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={6}>
                    <Form.Item label="主叫号码">
                      {getFieldDecorator('callNumber', {
                        initialValue: searchData.callNumber,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="通话轮次">
                      {getFieldDecorator('interactNum', {
                        initialValue: interactNum ? interactNum.split(',') : [],
                      })(
                        <Select placeholder="请选择" mode="multiple">
                          <Option value="0">0轮</Option>
                          <Option value="1">1轮</Option>
                          <Option value="2">2轮</Option>
                          <Option value="3">3轮</Option>
                          <Option value="4">4轮</Option>
                          <Option value="5">5轮</Option>
                          <Option value="6">6轮</Option>
                          <Option value="7">6轮以上</Option>
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="有效通话轮次">
                      {getFieldDecorator('usefulInteractNum', {
                        initialValue: usefulInteractNum
                          ? usefulInteractNum.split(',')
                          : [],
                      })(
                        <Select placeholder="请选择" mode="multiple">
                          <Option value="0">0轮</Option>
                          <Option value="1">1轮</Option>
                          <Option value="2">2轮</Option>
                          <Option value="3">3轮</Option>
                          <Option value="4">4轮</Option>
                          <Option value="5">5轮</Option>
                          <Option value="6">6轮</Option>
                          <Option value="7">6轮以上</Option>
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="通话时长">
                      {getFieldDecorator('lastTime', {
                        initialValue: lastTime ? lastTime.split(';') : [],
                      })(
                        <Select placeholder="请选择" mode="multiple">
                          <Option value="0,10">1-10秒</Option>
                          <Option value="10,30">10-30秒</Option>
                          <Option value="30,60">30秒-1分钟</Option>
                          <Option value="60,120">1分钟-2分钟</Option>
                          <Option value="120,600">2分钟以上</Option>
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={6}>
                    <Form.Item label="呼出时间">
                      {getFieldDecorator('taskCommitDate', {
                        initialValue: [
                          formatData(taskCommitDateStart),
                          formatData(taskCommitDateEnd),
                        ],
                      })(
                        <RangePicker
                          allowClear={false}
                          placeholder={['开始日期', '结束日期']}
                          showTime={{
                            hideDisabledOptions: true,
                            defaultValue: [
                              moment('00:00:00', 'HH:mm:ss'),
                              moment('23:59:59', 'HH:mm:ss'),
                            ],
                          }}
                          format="YYYY-MM-DD HH:mm:ss"
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="话术名称">
                      {getFieldDecorator('wordStrategyId', {
                        initialValue: searchData.wordStrategyId,
                      })(
                        <Select
                            showSearch
                            allowClear
                            placeholder="请输入内容"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }>
                          <Option value={-1}>全部</Option>
                          {Array.isArray(wordStrategyIdOptions)
                            ? wordStrategyIdOptions.map(
                                ({id, strategyName}) => (
                                  <Option
                                    value={id && parseInt(id, 10)}
                                    key={id}>
                                    {strategyName}
                                  </Option>
                                ),
                              )
                            : null}
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="CallId">
                      {getFieldDecorator('callId', {
                        initialValue: searchData.callId,
                      })(<Input placeholder="请输入内容" />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{marginBottom: 20}}>
                  <Col span={6}>
                    <Button type="primary" onClick={this.handleFilter}>
                      查询
                    </Button>
                    <Button style={{marginLeft: 8}} onClick={this.resetFilter}>
                      重置
                    </Button>
                    <a style={{marginLeft: 8}} onClick={this.toggle}>
                      <span>
                        收起<Icon type="up" />
                      </span>
                    </a>
                  </Col>
                </Row>
              </div>
            ) : null}
          </Form>
        )}
      </div>
    );
  }
}
const mapStateToProps = ({taskManageDetail}) => ({
  taskNameOptions: taskManageDetail.taskNameOptions,
  wordStrategyIdOptions: taskManageDetail.wordStrategyIdOptions,
  searchData: taskManageDetail.searchData,
  pageStatus: taskManageDetail.pageStatus,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tDetailActions, dispatch),
});

const SearchWrap = Form.create()(Search);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchWrap);
